import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {
  onGetDegrees,
  onGetDepartmentsByFacultyId,
  onGetEmailTemplates,
  onGetFaculties,
  onGetProgramsByDepAndSubDepId,
  onGetProgramTypesByDegreeId,
  onGetSubDepartmentsByDepartmentId,
  onGetUniversities,
  onGetUsers,
} from '../../../app/services/dataForComboBox/dataForComboBoxService'
import {
  onGetAllPagedEmailHistory,
  onGetAllUsersFiltered,
} from '../../../app/modules/send-email-system/components/email-history/core/_requests'

interface SendEmailState {
  emailTemplates: any
  universities: any
  faculties: any
  departments: any
  degrees: any
  programTypes: any
  subDepartments: any
  users: any
  emailHistories: any
  isLoading: boolean
}

const initialState = {
  emailTemplates: [],
  universities: [],
  faculties: [],
  departments: [],
  subDepartments: [],
  degrees: [],
  programTypes: [],
  users: [],
  emailHistories: [],
  isLoading: true,
} as SendEmailState

export const fetchEmailHistories = createAsyncThunk(
  'emailHistory/fetchEmailHistories',
  async (param: any) => {
    const data: any = await onGetAllPagedEmailHistory(param)
    return data.data.result
  }
)

export const fetchUsers = createAsyncThunk('emailHistory/fetchUsers', async (param: any) => {
  const data: any = await onGetAllUsersFiltered(param)
  return data.data.result
})

export const fetchEmailTemplates = createAsyncThunk(
  'emailHistory/fetchEmailTemplates',
  async () => {
    const data: any = await onGetEmailTemplates()
    return data.data.result
  }
)

export const fetchUniversities = createAsyncThunk('emailHistory/fetchUniversities', async () => {
  const data: any = await onGetUniversities()
  return data.data.result
})

export const fetchFaculties = createAsyncThunk(
  'emailHistory/fetchFaculties',
  async () => {
    const data: any = await onGetFaculties()
    return data.data.result
  }
)

export const fetchDepartments = createAsyncThunk(
  'emailHistory/fetchDepartments',
  async (param: any) => {
    const data: any = await onGetDepartmentsByFacultyId(param)
    return data.data.result
  }
)

export const fetchSubDepartments = createAsyncThunk(
  'emailHistory/fetchSubDepartments',
  async (param: any) => {
    const data: any = await onGetSubDepartmentsByDepartmentId(param)
    return data.data.result
  }
)

export const fetchDegrees = createAsyncThunk('emailHistory/fetchDegrees', async () => {
  const data: any = await onGetDegrees()
  return data.data.result
})

export const fetchProgramsByDepOrSubdep = createAsyncThunk(
  'sendEmail/fetchProgramsbyDepOrSubdep',
    async (param: any) => {
    const data: any = await onGetProgramsByDepAndSubDepId(param)
    return data.data.result
  }
)

// export const fetchProgramTypes = createAsyncThunk(
//   'emailHistory/fetchProgramTypes',
//   async (param: any) => {
//     const data: any = await onGetProgramTypesByDegreeId(param)
//     return data.data.result
//   }
// )

export const fetchProgramTypes = createAsyncThunk('emailHistory/fetchProgramTypes', async () => {
  const data: any = await onGetDegrees()
  return data.data.result
})


const emailHistorySlice = createSlice({
  name: 'emailHistory',
  initialState,
  reducers: {
    clearEmailHistories: (state) => {
      state.emailHistories = []
    },
    clearAllFilters: (state) => {
      //state.faculties = []
      state.departments = []
      state.subDepartments = []
      state.programTypes = []
      state.users = []
    },
    activateLoading: (state) => {
      state.isLoading = true
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchUsers.fulfilled, (state: any, action) => {
      state.users = action.payload.items
    })
    builder.addCase(fetchUniversities.fulfilled, (state: any, action) => {
      state.universities = action.payload.items
    })
    builder.addCase(fetchFaculties.fulfilled, (state: any, action) => {
      state.faculties = action.payload.items
    })
    builder.addCase(fetchDepartments.fulfilled, (state: any, action) => {
      state.departments = action.payload.items
    })
    builder.addCase(fetchSubDepartments.fulfilled, (state: any, action) => {
      state.subDepartments = action.payload.items
    })
    builder.addCase(fetchDegrees.fulfilled, (state: any, action) => {
      state.degrees = action.payload.items
    })
    builder.addCase(fetchProgramTypes.fulfilled, (state: any, action) => {
      state.programTypes = action.payload.items
    })
    builder.addCase(fetchEmailTemplates.fulfilled, (state: any, action) => {
      state.emailTemplates = action.payload.items
    })
    builder.addCase(fetchEmailHistories.fulfilled, (state: any, action) => {
      state.emailHistories = action.payload
    })
    builder.addCase(fetchProgramsByDepOrSubdep.fulfilled, (state: any, action) => {
      state.programfromDepOrSubdeps = action.payload.items
    })
  },
})

export const {clearAllFilters, clearEmailHistories} = emailHistorySlice.actions

export default emailHistorySlice.reducer
